import { v4 as uuid } from 'uuid';
import { alertsConstants } from '../constants';

const AUTO_CLEAR_SECS = 5000;
const success = (message: string, skipClear = false) => {
  return _base(
    { type: alertsConstants.SUCCESS, payload: { message } },
    skipClear,
  );
};

const info = (message: string, skipClear = false) => {
  return _base(
    { type: alertsConstants.INFO, payload: { message } },
    skipClear,
  );
};

const error = (message: string | string[], skipClear = false) => {
  if (Array.isArray(message)) {
    message = `${message}`;
  }
  return _base(
    { type: alertsConstants.ERROR, payload: { message } },
    skipClear,
  );
};

const _base = (
  actionObj: { type: string; payload: { message: string } },
  skipClear = false,
) => {
  return (dispatch) => {
    const id = uuid();
    dispatch({ ...actionObj, payload: { ...actionObj.payload, id } });
    // auto clear after 3 secs
    if (!skipClear)
      setTimeout(() => dispatch(clear({ id })), AUTO_CLEAR_SECS);
  };
};

const clear = ({
  id,
  message,
}: {
  id?: string;
  message?: string;
}) => {
  const keyFocus = id !== undefined ? 'id' : 'message';
  const valFocus = id ?? message;
  return {
    type: alertsConstants.CLEAR,
    payload: { [keyFocus]: valFocus },
  };
};

const clearAll = () => {
  return {
    type: alertsConstants.CLEAR_ALL,
  };
};

export const alertsActions = {
  success,
  info,
  error,
  clear,
  clearAll,
};
